import React from 'react';
import moment from 'moment';
import { Tag } from 'antd';

export const columns = [
    {
        title: 'User',
        dataIndex: 'user',
        render: (user: any) => user?.fullName || user?.username || '-',
    },
    {
        title: 'Email',
        dataIndex: ['user', 'email'],
        render: (email: string) => email || '-',
    },
    {
        title: 'Phone Number',
        dataIndex: ['user', 'msisdn'],
    },
    {
        title: 'Subscription',
        dataIndex: ['subscription', 'name'],
        render: (name: string) => name || '-',
    },
    {
        title: 'Free Plays',
        dataIndex: 'freePlaysUsed',
        render: (freePlaysUsed: number, record: any) => {
            const totalFreePlays = record?.subscription?.numberOfFreePlays ?? 0;
            return `${freePlaysUsed ?? 0}/${totalFreePlays}`;
        },
    },
    {
        title: 'Remaining Free Plays',
        dataIndex: 'remainingFreePlays',
        render: (remainingFreePlays: number) => remainingFreePlays ?? 0,
    },
    {
        title: 'Played Sessions',
        dataIndex: 'playedSessions',
        render: (playedSessions: any[]) => <Tag color="blue">{playedSessions?.length ?? 0}</Tag>,
    },
    {
        title: 'Subscribed At',
        dataIndex: 'subscribedAt',
        render: (subscribedAt: string) => (subscribedAt ? moment(subscribedAt).format('DD/MM/YYYY HH:mm') : '-'),
    },
];
